<div *ngFor="let category of mainCategories">
    <button mat-menu-item [class.category-button-selected]="category.id == selectedCategory">
        <mat-icon>remove</mat-icon>
        <span (click)="changeCategory(category)">{{category.nombre}}</span>
    </button>
     <div *ngIf="category.hasSubCategory" class="sub-category">
        <app-category-list [categories]="categories" [categoryParentId]="category.id" 
        [selectedCategory]="selectedCategory"  (change)="changeCategory($event)"></app-category-list>
    </div>
</div>